'use client';

import { useSaveTripToast } from '~/components/Journey/SaveTripToast/useSaveTripToast';
import { TRPC_SETTINGS } from '~/constants/trpc';
import { useTripId } from '~/hooks/useTripId';
import { api } from '~/libs/api';
import { deriveTripEditability } from './lib/tripEditability';

export const TripSaveTripPrompt = () => {
  const tripId = useTripId();
  const { data: overviewData } = api.trip.getOverview.useQuery(
    { tripId },
    { ...TRPC_SETTINGS.QUERY_NO_REFETCH, enabled: !!tripId, keepPreviousData: true }
  );
  const { isBooked } = deriveTripEditability(overviewData);

  useSaveTripToast({
    tripId: isBooked ? undefined : tripId,
    tripTitle: overviewData?.journeyTitle ?? '',
    revealDepthPercent: 25,
    revealScrollUpPercent: 20
  });

  return null;
};
